<template>
	<div>
		<Dialog v-bind:value="value" @input="$emit('input', $event)"
						title="Neue Zone anlegen"
						@ok="submit" :loading="loading"
						@cancel="cancel">
			<v-alert
				outlined
				type="warning"
				border="left"
			>
				Mit dem Speichern wird - soweit nicht vorhanden - die Zone im Ad Manager angelegt.
			</v-alert>
			<Input v-model="name" label="Bezeichnung"
						 :error-messages="nameErrors"
						 :required="true"
						 @input="$v.name.$touch()"
						 @blur="$v.name.$touch()"></Input>
			<Dropdown v-model="oop" :items="active_options" label="Out of Page Slot"
								@input="$v.oop.$touch()"
								@blur="$v.oop.$touch()"></Dropdown>
			<Dropdown v-model="interstitial" :items="active_options" label="Mobile Interstitial"
								@input="$v.interstitial.$touch()"
								@blur="$v.interstitial.$touch()"></Dropdown>
			<v-autocomplete
				v-model="parent"
				:items="zones"
				label="Parent"
				item-text="Name"
				item-value="Name"
				:color="ada.blue"
				flat
				return-object
				no-data-text="Keine Daten"
				@input="$v.parent.$touch()"
				@blur="$v.parent.$touch()"
			>
				<template v-slot:selection="data">
					{{ data.item.zone_name || data.item.Name }}
				</template>
				<template v-slot:item="data">
					<span>{{ data.item.Name }}</span>
				</template>
			</v-autocomplete>
			<Toggle v-model="disablePositions" label="Alle Positionen deaktivieren"></Toggle>
		</Dialog>
		<Snackbar v-model="successSnackbar" color="success">Zone erfolgreich angelegt.</Snackbar>
	</div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Input from "../../../components/Inputs/Input";
import Utils from "../../../scripts/Utils";
import Dropdown from "../../../components/Inputs/Dropdown";
import Toggle from "../../../components/buttons/Toggle";
import Snackbar from "../../../components/Snackbar";
import ada from "../../../scss/ada_colors.scss";

export default {
	name: "AddZoneDialog",
	components: {Snackbar, Toggle, Dropdown, Input, Dialog},
	props: ['value'],
	mixins: [validationMixin],
	validations: {
		name: {required},
		oop: {required},
		interstitial: {required},
		parent: {required},
	},
	data: () => {
		return {
			name: null,
			oop: -1,
			interstitial: -1,
			parent: null,
			disablePositions: 0,
			active_options: [
				{text: 'Parent', value: -1},
				{text: 'Aktiviert', value: 1},
				{text: 'Deaktiviert', value: 0}],
			boolean_options: [
				{text: 'nein', value: 0},
				{text: 'ja', value: 1},
			],
			successSnackbar: false,
			loading: false,
			ada,
		}
	},
	mounted() {
		if (this.siteDetails) this.parent = this.zones[0];
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		zones() {
			if (this.siteDetails) {
				return this.siteDetails.Zones;
			}
			return [];
		},
		selectedSite() {
			return this.vuexState.selectedSite;
		},
		nameErrors() {
			return Utils.handleError(this, 'name', 'Name ist erforderlich.');
		},
		oopErrors() {
			return Utils.handleError(this, 'oop', 'Out of Page Slots ist erforderlich.');
		},
		interstitialErrors() {
			return Utils.handleError(this, 'interstitial', 'Mobile Intersitial ist erforderlich.');
		},
		parentErrors() {
			return Utils.handleError(this, 'parent', 'Parent ist erforderlich.');
		},
		validate() {
			return this.nameErrors.length === 0;
		}
	},
	methods: {
		init() {
			this.name = null;
			this.oop = -1;
			this.interstitial = -1;
			this.parent = this.zones[0] || null;
		},
		async submit() {
			this.$v.$touch()
			if (this.validate) {
				this.loading = true;
				let data = await this.$store.dispatch('zones/createZone', this.getBody());
				if (data.Status) {
					this.successSnackbar = true;
					this.close();
				} else {
					this.$root.$emit('snackbar', 'Fehler beim Erstellen der Zone. Existiert diese Zone evtl. schon?', 'error')
				}
				this.loading = false;
			}
		},
		getBody() {
			return {
				publisher_id: this.selectedSite.PublisherId,
				site_id: this.siteDetails.Site.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
				Name: this.name ? this.name.trim() : null,
				Oop: this.oop.value,
				Interstitial: this.interstitial.value,
				disableAdPositions: this.disablePositions,
				parent_id: this.parent.ZoneId
			}
		},
		cancel() {
			if (this.loading) {
				this.$store.commit('zones/cancelRequest', 'createZone');
				this.loading = false;
			}
			this.close();
		},
		close() {
			this.init()
			this.$v.$reset();
			this.$emit('input', false); // set v-model to false -> close dialog
		}
	},
	watch: {
		siteDetails() {
			this.parent = this.zones[0];
		},
	}
}
</script>

<style scoped>
.label {
	font-size: 16px;
	position: relative;
	top: 5px;
}
</style>